// The merchant's REAL store. Every account gets an empty auto-created `stores` row
// ("my-store") at signup, while the store the merchant actually built lives in
// `store_settings`. The default store is therefore the merchant's store_settings row
// (oldest first, same rule as the /abonnement page); the `stores` row is only a
// fallback for accounts that have no store_settings at all.

type Row = { id: string; created_at?: string | null };

const oldestFirst = <T extends Row>(rows: T[] | null | undefined): T[] =>
  [...(rows ?? [])].sort((a, b) => String(a.created_at ?? "").localeCompare(String(b.created_at ?? "")));

export function pickRealStore<S extends Row, T extends Row>(
  settingsRows: S[] | null | undefined,
  storesRows: T[] | null | undefined,
): { source: "store_settings"; row: S } | { source: "stores"; row: T } | null {
  const s = oldestFirst(settingsRows)[0];
  if (s) return { source: "store_settings", row: s };
  const t = oldestFirst(storesRows)[0];
  if (t) return { source: "stores", row: t };
  return null;
}
